module.exports = __webpack_public_path__ + "img/blank-map-not-found.95cd9def.png";